module.exports = __webpack_public_path__ + "img/ic_talking_green.61cf4561.svg";